import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ImportButton } from "@/features/imports/components";

interface TransactionsHeaderProps {
  onAddTransaction: () => void;
}

export const TransactionsHeader: React.FC<TransactionsHeaderProps> = ({
  onAddTransaction,
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-3xl font-bold">Transactions</h1>

      <div className="flex items-center gap-2">
        <ImportButton context="transactions" />
      </div>
    </div>
  );
};
